import { render } from "./BrandCardPopup.vue?vue&type=template&id=1f17eade"
import script from "./BrandCardPopup.vue?vue&type=script&lang=js"
export * from "./BrandCardPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__